import styled from 'styled-components'

export const ArrowButton = styled.button`
  align-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  border-radius: 28px;
  cursor: pointer;
  outline: none;
  margin: -10px 0;
  padding: 0;
  transition: transform 0.2s ease-in-out;
  width: 28px;
  height: 28px;
  background-color: ${({ theme }) => theme.colors.bgCard};
  z-index: 10;

  img {
    width: 28px;
    height: 28px;
  }

  &:hover {
    transform: rotate(180deg);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`
